export {}

async function getAvailableEnergyTypes(realEstateId: number): Promise<number[]> {
    try {
        const response = await fetch(`/Widget/GetAvailableEnergyTypes?realEstateId=${realEstateId}`)

        if (!response.ok) {
            console.error(`Failed to fetch available energy types. HTTP status: ${response.status}`)
            return []
        }

        return await response.json()
    } catch (error) {
        console.error("Error fetching available energy types:", error)
        return []
    }
}

declare global {
    interface Window {
        getAvailableEnergyTypes: typeof getAvailableEnergyTypes
    }
}

window.getAvailableEnergyTypes = getAvailableEnergyTypes
